import React from "react";

import * as S from "./styles";

type ToggleButtonsPropsT = {
  buttonOptions: {
    label: string;
    value: string | number | boolean;
  }[];
  value: string | number | boolean;
  updateValue: React.Dispatch<React.SetStateAction<string | number | boolean>>;
};

const ToggleButtons = ({ value, updateValue, buttonOptions }: ToggleButtonsPropsT) => {
  return (
    <S.StyledToggleViewButtons
      exclusive
      value={value}
      onChange={(_, newVal) => {
        if (newVal !== null) updateValue(newVal);
      }}
    >
      {buttonOptions.map((opt) => (
        <S.StyledToggleButton disableRipple key={opt.value} value={opt.value}>
          {opt.label}
        </S.StyledToggleButton>
      ))}
    </S.StyledToggleViewButtons>
  );
};

export default ToggleButtons;
